import React, { Component, Fragment } from "react";
import classNames from "classnames";
import { Link as RouterLink } from 'react-router-dom';
import { isSessionSwitchPathBlocked } from 'common/roles/adminAccess';
import { Typography, Card, Fab } from '@mui/material';
import compose from "recompose/compose";
import _ from "lodash";
import { withStyles } from '@mui/styles'
import { withRouter } from 'common/utils/router.util';
import { useMediaQuery, useTheme } from '@mui/material';
import styles from "./styles";
import { WebsiteLayout } from "layouts";
import {
  IsValidLoginAuth,
  IsValidSemiAuth,
  GetStateStorage,
} from "common/storage";
import Constants from "common/constants";
import Base from "common/constants";
import DocumentTitle from "react-document-title";
import querystring from "querystring";
import { GetFreeAreasByCountyID } from "services/agent";
import { connect } from "react-redux";
import { homeConstants } from "_constants/home.constant";
import { getPMAReviewandApprovalDateForAAgentFromSchedule } from "../Schedule/MailingScheduleServices";
import moment from "moment";
import { handleLogoutFn } from "common/helpers";
import CryptoJS from "crypto-js";
import { GetOAuthToken } from "common/storage";
import { isUserAgent, isUserBrokerAdmin } from "common/roles/role";
import {
  getAgentDetailsUrl,
  isAnyAgentLogoAdded,
  isAnyAgentPhotoAdded,
  isAnyAreaTaglineAdded,
  isMissionStatementSelected,
  isAnyTestimonialAdded,
  isBrokerageDetailsIncomplete,
  PROFILE_ROUTES,
} from "common/helpers/profileCompleteness";
import BrokerageOfficeDialog from "./component/BrokerageOfficeDialog";
import { LegalContractChecker } from "components";

// Hides links to screens blocked for a session-switched restricted admin (see common/roles/adminAccess)
const Link = ({ to, ...rest }) =>
  isSessionSwitchPathBlocked(typeof to === 'string' ? to : (to || {}).pathname) ? null : <RouterLink to={to} {...rest} />;



class HomeScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      showCutOff: true,
      isChrome: false,
      isValidLogin: false,
      isValidSemiLogin: false,
      userData: {},
      isValidROICounty: false,
      availableAreas: 0,
      countyID: 0,
      openSplitButton: true,
      cutoffDate: null,
      reviewMonthName: null,
      reviewDateStart: null,
      printStartDate: null,
    };
    // Store reload page check for componentDidMount
    this.reloadPageCheck = null;
    try {
      let parsedParams = querystring.parse(props.location.search.substring(1));
      this.reloadPageCheck = parsedParams.reloadPage;
    } catch (err) {
      console.log(err);
    }

    this.anchorRef = React.createRef();
  }

  handleOpen = () => {
    this.setState({
      open: true,
    });
  };

  handleClose = () => {
    this.setState({
      open: false,
    });
  };

  redirectToRegister = () => { };

  redirectToPMA = () => { };

  handleStateDelayProblem = (isValidLogin) => {
    const startIntervel = setInterval(() => {
      let localStateData = GetStateStorage();
      let userData = localStateData ? localStateData : {};
      if (userData.userData && userData.userData.countyID) {
        //its only be valid if agent is registered not in registration process
        let isValidROICounty =
          isValidLogin && userData.userData && userData.userData.countyID;
        //&&
        //Number(userData.userData.countyID) !== 27;
        //clear the intervel also
        clearInterval(startIntervel);
        this.setState(
          (prevState) => ({
            userData: { ...prevState.userData, ...userData },
            isValidROICounty: isValidROICounty,
            countyID: Number(userData.userData.countyID),
          }),
          () => {
            if (isValidROICounty && this.props.availableCountyAreas === 0) {
              this.getCountyFreeAreaData(userData.userData.countyID);
            }
            if (isValidLogin) {
              this.handleScheuleData(userData.userData);
            }
          }
        );
      }
    }, 300);
  };

  componentDidMount = () => {
    window.scrollTo(0, 0);

    // Handle reload page check
    // Avoid forcing a push to /home on mount; Router default redirect handles it

    let localStateData = GetStateStorage();
    let isValidLogin = IsValidLoginAuth();
    let isValidSemiLogin = IsValidSemiAuth();

    if (window) {
      let isChrome =
        /Chrome/.test(navigator.userAgent) &&
        /Google Inc/.test(navigator.vendor);
      let userData = localStateData ? localStateData : {};
      let isValidROICounty =
        isValidLogin && userData.userData && userData.userData.countyID;
      //&&
      //Number(userData.userData.countyID) !== 27;
      //here the user data will set after calling the profile api so complete userdata wont be there only token data would be there. so use the token data
      this.setState(
        (prevState) => ({
          isChrome,
          isValidLogin,
          isValidSemiLogin,
          userData: {
            ...prevState.userData,
            ...(userData.userData ? userData : {}),
          }, //here if we dont put this condition then for agetn account by default it will show other button except ROI button with no listgen profile user data so when we click on buttons it will show no acess.basically it measn profile api data is loaded and this problem only comes when we come from login screen directly. for other cases like refreshing page, coming from other screen this problem is not there.
          isValidROICounty: isValidROICounty,
          countyID:
            userData.userData &&
            userData.userData.countyID &&
            Number(userData.userData.countyID),
        }),
        () => {
          if (!userData.userData) {
            // there is a catch if profile api is loading late then we need to call this method so we can update store by using intervel
            this.handleStateDelayProblem(isValidLogin);
          } else {
            if (isValidROICounty && this.props.availableCountyAreas === 0) {
              this.getCountyFreeAreaData(userData.userData.countyID);
            }
            isValidLogin && this.handleScheuleData(userData.userData);
          }
        }
      );
    }
  };

  handleScheuleData = (userData) => {
    //check for review end date
    getPMAReviewandApprovalDateForAAgentFromSchedule(
      userData || {},
      (cutoffDate, cutoffMonth, reviewDateStart, printStartDate) => {
        this.setState({
          cutoffDate: cutoffDate,
          cutoffMonth: cutoffMonth,
          reviewDateStart: reviewDateStart,
          printStartDate: printStartDate
        });
      }
    );
  };

  getCountyFreeAreaData = (countyID) => {
    GetFreeAreasByCountyID(countyID)
      .then((data) => {
        //this.setState({ availableAreas: data });
        this.props.updateAvailableAreaCount({
          type: homeConstants.UPDATE_AVAILABLE_AREA_COUNT,
          payload: data,
        });
      })
      .catch((err) => { });
  };

  handleROIClick = () => {
    let countyMapObj = Base.COUNTY_ID_NAME_MAP;
    const {
      userData: { userData },
    } = this.state;
    let countyID = userData.countyID ? userData.countyID : 42;
    const { history } = this.props;

    history.push(
      `/agent/areas-by-city?emailAddress=${userData.emailAddress}&listgenUserFirstName=${userData.listgenUserFirstName}&listgenUserLastName=${userData.listgenUserLastName}&brokerageName=${userData.brokerageName}&countyID=${countyID}&countyName=${countyMapObj[countyID]}&listgenUserID=${userData.listgenUserID}&agentLicenseNumber=${userData.agentLicenseNumber}`
    );
  };

  handleBrokerAdminClick = () => {
    const {
      userData: { userData },
    } = this.state;
    const { listgenUserID, countyID, officeID, listgenRoleID } = userData;
    const safeOfficeID = officeID || 'PRP1001';

    const isDev = process.env.NODE_ENV === 'development';
    const secret = process.env.REACT_APP_BROKER_TOKEN_SECRET || 'lg-broker-secret';
    // ?t= carries identity only (who-are-you), not credentials.
    // Cookie (LG_ACCESS, Domain=.listgen.com) handles actual auth on broker.listgen.com.
    const { access_token, refresh_token, ...meta } = JSON.parse(GetOAuthToken() || '{}');
    const encrypted = CryptoJS.AES.encrypt(JSON.stringify(meta), secret).toString();
    const encodedToken = encodeURIComponent(encrypted);

    const brokerHost = isDev ? 'http://localhost:3002' : 'https://broker.listgen.com';
    const brokerUrl = `${brokerHost}/auth/${listgenUserID}/${countyID}/${safeOfficeID}/${listgenRoleID}?t=${encodedToken}`;
    console.log('[handleBrokerAdminClick] url:', brokerUrl);
    window.location.href = brokerUrl;
  };

  render() {
    const { classes, availableCountyAreas } = this.props;
    const {
      isChrome,
      userData,
      isValidLogin,
      isValidSemiLogin,
      isValidROICounty,
      countyID,
    } = this.state;

    let isAgentSession =
      isUserAgent(userData.userRole);
    const isBrokerAdminSession = isUserBrokerAdmin(userData.userRole);
    const stateData = GetStateStorage();
    const agentData = (stateData || {}).userData;
    let navbarData =
      agentData &&
      Array.isArray(agentData.navbarInfo) &&
      agentData.navbarInfo[0];

    const isAnyAreaTaglineExist = isAnyAreaTaglineAdded(
      (agentData || {}).navbarInfo
    );
    const anyTestimonialAdded = isAnyTestimonialAdded(agentData);
    const anyMissionStatementAdded = isMissionStatementSelected(agentData);
    const isAnyLogoAdded = isAnyAgentLogoAdded(agentData);
    const isAnyPhotoAdded = isAnyAgentPhotoAdded(agentData);
    const isBrokerageIncomplete = isBrokerageDetailsIncomplete(agentData);

    return (
      <DocumentTitle title="Welcome to ListGen">
        <Fragment>
          <BrokerageOfficeDialog />
          <LegalContractChecker />
          <WebsiteLayout gradientMode={true} hideFooter={true} width={this.props.width}>
            <div className={classNames(classes.root)}>
            {/* <div className={classes.bgBackground}> */}
            {/* <Grid
              className={classNames(classes.grid, classes.backgroundGradient)}
              container
            >
              <Grid item lg={12} sm={12} xs={12} md={12}> */}
            <div className={classes.homeImageHeader}>
              <div className={classes.textOverImage}>
                <div
                  className={classNames(
                    classes.gridButtonDesign,
                    classes.firstGridWidth
                  )}
                >
                  <div className={classes.gridInnerButtonDesign}>
                    {/* //only show opma button if its an agent account */}
                    {isBrokerAdminSession && (
                      <Fragment>
                        <Link to="/account">
                          <Fab
                            variant="extended"
                            color="default"
                            //onClick={this.handleOpen}
                            className={classNames(
                              classes.whiteBorderButton,
                              classes.whiteBorderButtonSmall,
                              classes.fabBottomMargin
                            )}
                            size="small"
                          >
                            Change Email
                          </Fab>
                        </Link>
                        <Link to="/account">
                          <Fab
                            variant="extended"
                            color="default"
                            //onClick={this.handleOpen}
                            className={classNames(
                              classes.whiteBorderButton,
                              classes.whiteBorderButtonSmall,
                              classes.fabBottomMargin
                            )}
                            size="small"
                          >
                            Change Password
                          </Fab>
                        </Link>
                      </Fragment>
                    )}
                    {isValidLogin && !isValidSemiLogin && isAgentSession ? (
                      <Fragment>
                        {/* {!this.state.openSplitButton && (
                          <Fab
                            variant="extended"
                            color="default"
                            onClick={() =>
                              this.setState((prevState) => ({
                                openSplitButton: !prevState.openSplitButton,
                              }))
                            }
                            className={classNames(
                              classes.whiteBorderButton,
                              classes.whiteBorderButtonSmall
                            )}
                            size="small"
                          >
                            VIEW OPTIONS
                          </Fab>
                        )} */}
                        {this.state.openSplitButton ? (
                          <Fragment>
                            <Link
                              to={getAgentDetailsUrl(userData.userID)}
                            >
                              <Fab
                                variant="extended"
                                color="default"
                                //onClick={this.handleOpen}
                                className={classNames(
                                  classes.whiteBorderButton,
                                  classes.whiteBorderButtonSmall,
                                  classes.fabBottomMargin
                                )}
                                size="small"
                              >
                                Edit Profile
                              </Fab>
                            </Link>

                            <Link
                              to={getAgentDetailsUrl(userData.userID, '#agent-photo-section')}
                            >
                              <Fab
                                variant="extended"
                                color="default"
                                className={classNames(
                                  classes.whiteBorderButton,
                                  classes.whiteBorderButtonSmall,
                                  classes.fabBottomMargin,
                                  !isAnyPhotoAdded &&
                                  classes.incompleteDetailsOrRedButton,
                                  !isAnyPhotoAdded && classes.flashButton
                                )}
                                size="small"
                              >
                                {/* {isAnyPhotoAdded ? 'Edit' : 'Add'} Photo */}
                                Your Photo
                              </Fab>
                            </Link>

                            <Link
                              to={getAgentDetailsUrl(userData.userID, '#agent-logo-section')}
                            >
                              <Fab
                                variant="extended"
                                color="default"
                                className={classNames(
                                  classes.whiteBorderButton,
                                  classes.whiteBorderButtonSmall,
                                  classes.fabBottomMargin,
                                  !isAnyLogoAdded &&
                                  classes.incompleteDetailsOrRedButton,
                                  !isAnyLogoAdded && classes.flashButton
                                )}
                                size="small"
                              >
                                {/* {isAnyLogoAdded ? 'Edit' : 'Add'} Logo */}
                                Your Logo
                              </Fab>
                            </Link>

                            <Link
                              to={getAgentDetailsUrl(userData.userID, '#area-tagline-section')}
                            >
                              <Fab
                                variant="extended"
                                color="default"
                                //onClick={this.handleOpen}
                                className={classNames(
                                  classes.whiteBorderButton,
                                  classes.whiteBorderButtonSmall,
                                  classes.fabBottomMargin,
                                  !isAnyAreaTaglineExist &&
                                  classes.incompleteDetailsOrRedButton,
                                  !isAnyAreaTaglineExist && classes.flashButton
                                )}
                                size="small"
                              >
                                {/* {isAnyAreaTaglineExist ? 'Edit' : 'Add'} Area Taglines */}
                                Area Taglines
                              </Fab>
                            </Link>

                            <Link
                              to={`/cards/credit/ag/${btoa(
                                userData.userID
                              )}/${btoa(null)}/${btoa(null)}/${btoa(null)}`}
                            >
                              <Fab
                                variant="extended"
                                color="default"
                                //onClick={this.handleOpen}
                                className={classNames(
                                  classes.whiteBorderButton,
                                  classes.whiteBorderButtonSmall,
                                  classes.fabBottomMargin
                                )}
                                size="small"
                              >
                                Edit Credit Card
                              </Fab>
                            </Link>

                            <Link to="/account">
                              <Fab
                                variant="extended"
                                color="default"
                                //onClick={this.handleOpen}
                                className={classNames(
                                  classes.whiteBorderButton,
                                  classes.whiteBorderButtonSmall,
                                  classes.fabBottomMargin
                                )}
                                size="small"
                              >
                                Change Password
                              </Fab>
                            </Link>
                            <Link to={PROFILE_ROUTES.CLIENT_TESTIMONIALS}>
                              <Fab
                                variant="extended"
                                color="default"
                                //onClick={this.handleOpen}
                                className={classNames(
                                  classes.whiteBorderButton,
                                  classes.whiteBorderButtonSmall,
                                  classes.fabBottomMargin,
                                  !anyTestimonialAdded &&
                                  classes.incompleteDetailsOrRedButton,
                                  !anyTestimonialAdded && classes.flashButton
                                )}
                                size="small"
                              >
                                {/* {!anyTestimonialAdded ? "Add Client Testimonials" : 'Select a Client Testimonial'} */}
                                Client Testimonials
                              </Fab>
                            </Link>
                            <Link to={PROFILE_ROUTES.MISSION_STATEMENTS}>
                              <Fab
                                variant="extended"
                                color="default"
                                //onClick={this.handleOpen}
                                className={classNames(
                                  classes.whiteBorderButton,
                                  classes.whiteBorderButtonSmall,
                                  classes.fabBottomMargin,
                                  !anyMissionStatementAdded &&
                                  classes.incompleteDetailsOrRedButton,
                                  !anyMissionStatementAdded &&
                                  classes.flashButton
                                )}
                                size="small"
                              >
                                {/* {!anyMissionStatementAdded ? 'Add Mission Statements' : "Select a Mission Statement"} */}
                                Your Mission Statement
                              </Fab>
                            </Link>
                            <Link
                              to={getAgentDetailsUrl(userData.userID, '#brokerage-office-section')}
                            >
                              <Fab
                                variant="extended"
                                color="default"
                                className={classNames(
                                  classes.whiteBorderButton,
                                  classes.whiteBorderButtonSmall,
                                  classes.fabBottomMargin,
                                  isBrokerageIncomplete &&
                                    classes.incompleteDetailsOrRedButton,
                                  isBrokerageIncomplete && classes.flashButton
                                )}
                                size="small"
                              >
                                Brokerage Office Location
                              </Fab>
                            </Link>

                            {/* {this.state.openSplitButton && <div className={classes.closeMenuButton} onClick={() => this.setState((prevState) => ({ openSplitButton: !prevState.openSplitButton }))}>CLOSE OPTIONS</div>} */}
                          </Fragment>
                        ) : null}
                      </Fragment>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                {/* //className={classes.innerTOIBlock} */}
                <div
                  className={classNames(
                    classes.gridButtonDesign,
                    classes.gridButtonDesignMiddle,
                    classes.secondGridWidth
                  )}
                >
                  <div className={classes.textOIButtons}>
                    {!isChrome ? (
                      <div className={classes.useChromeSection}>
                        <Card className={classes.notChromeCard}>
                          Looks like your not using chrome. We recommend using
                          Chrome for best results.
                        </Card>
                      </div>
                    ) : (
                      ""
                    )}
                    {!isValidLogin && isValidSemiLogin ? (
                      <Link to="/agent/register">
                        <Fab
                          variant="extended"
                          color="default"
                          //onClick={this.handleOpen}
                          className={classes.whiteBorderButton}
                        >
                          CLICK HERE TO REGISTER
                        </Fab>
                      </Link>
                    ) : (
                      ""
                    )}
                    {/* //only show opma button if its an agent account */}
                    {isValidLogin && !isValidSemiLogin && !isBrokerAdminSession ? (
                      <Fragment>
                        <div className={classes.pmaFragment} style={{ marginTop: "16px" }}>
                          {this.state.showCutOff && (
                            <div className={classes.cutOffMargin}>
                              {/* Go Live Box - Hide when review date has passed */}
                              {moment(this.state.reviewDateStart).isAfter(moment()) && (
                                <div
                                  className={classes.flashButton}
                                  style={{
                                    marginBottom: "16px",
                                    fontSize: "22px",
                                    lineHeight: "1.3",
                                    fontWeight: '500'
                                  }}
                                >
                                  <p>Your all-new {this.state.cutoffMonth} PMAs will be ready to REVIEW & APPROVE on<br /> {moment(this.state.reviewDateStart).format("dddd MMMM Do")}</p>
                                </div>
                              )}

                              {/* Final Approval Box - Show red box when review date has passed, hide when print start date has passed */}
                              {this.state.cutoffDate && this.state.printStartDate && moment(this.state.printStartDate).isAfter(moment()) && (
                                <div
                                  className={moment(this.state.reviewDateStart).isBefore(moment()) ? classNames(classes.finalApprovalRedBox, classes.flashButton) : classes.normalApprovalText}
                                >
                                  <p>The Final Approval Date for your {this.state.cutoffMonth} mailing is</p>
                                  <p>
                                    {moment(this.state.cutoffDate).format(
                                      "dddd MMMM Do @ h A"
                                    )}
                                  </p>
                                </div>
                              )}
                            </div>
                          )}
                          {/* {isAgentSession ? (<Link to="/mailpro">
                            <div className={classes.newHOSection}>
                              <Typography variant="body1" color="inherit">
                                You have 10 new homeowners in 3 of your area's ready to be personalized
                              </Typography>
                            </div>
                          </Link>) : null} */}
                          <div className={classes.pmaFragmentButtons}>
                            {isAgentSession ? (
                              <Fragment>
                                <Link to={`/pma/${navbarData.mlsAreaID}`}>
                                  <Fab
                                    variant="extended"
                                    color="default"
                                    //onClick={this.handleOpen}
                                    className={classes.whiteBorderButton}
                                    size="medium"
                                  >
                                    BUILD YOUR PRECISION MARKET ANALYSIS
                                  </Fab>
                                  {/* <Fab
                                    variant="extended"
                                    color="default"
                                    //onClick={this.handleOpen}
                                    className={classNames(classes.whiteBorderButton, classes.whiteBorderButtonSmall, classes.greenBgButton)}
                                    size="medium"
                                  >
                                    REVIEW and APPROVE YOUR PRECISION MARKET ANALYSIS
                            </Fab> */}
                                </Link>
                                <Link to={`/mailpro/${navbarData.mlsAreaID}`}>
                                  <Fab
                                    variant="extended"
                                    color="default"
                                    //onClick={this.handleOpen}
                                    className={classes.whiteBorderButton}
                                    size="medium"
                                    style={{ marginTop: "32px" }}
                                  >
                                    Go to MailPro
                                  </Fab>
                                </Link>
                              </Fragment>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      </Fragment>
                    ) : (
                      ""
                    )}

                    {/* //For broker admin */}
                    {isBrokerAdminSession && (
                      <Fragment>
                          <Fab
                            variant="extended"
                            color="default"
                            onClick={this.handleBrokerAdminClick}
                            className={classes.whiteBorderButton}
                          >
                            Manage Agents
                          </Fab>
                      </Fragment>)}
                  </div>
                </div>
                <div
                  className={classNames(
                    classes.gridButtonDesign,
                    classes.thirdGridWidth
                  )}
                >
                  <div className={classes.gridInnerButtonDesign}>
                    {/* //only show opma button if its an agent account */}
                    {isValidLogin && !isValidSemiLogin && isAgentSession ? (
                      <Fragment>
                        {/* <Link to="/agent/areas-by-city"> */}
                        {isValidROICounty && !isSessionSwitchPathBlocked("/agent/areas-by-city") ? (
                          <div>
                            <Fab
                              variant="extended"
                              color="default"
                              //onClick={this.handleOpen}
                              className={classNames(
                                classes.whiteBorderButton,
                                classes.whiteBorderButtonSmall
                              )}
                              size="small"
                              onClick={(event) => this.handleROIClick()}
                            >
                              Neighborhood Selection Tool
                            </Fab>
                            {availableCountyAreas > 0 ? (
                              <Typography
                                variant="subtitle2"
                                component="p"
                                className={classes.areaAvailable}
                              >
                                {availableCountyAreas} Areas Available
                              </Typography>
                            ) : (
                              ""
                            )}
                          </div>
                        ) : (
                          ""
                        )}

                        <Link to="/schedule" style={{ marginTop: "24px" }}>
                          {/* <div style={{ height: '72px', width: '72px'}}></div> */}
                          <Fab
                            variant="extended"
                            color="default"
                            //onClick={this.handleOpen}
                            className={classNames(
                              classes.whiteBorderButton,
                              classes.whiteBorderButtonSmall
                            )}
                            size="small"
                          >
                            {/* <span className={classes.newTextWithoutBorder}>
                              New
                            </span> */}
                            &nbsp;View Mailing Calendar
                          </Fab>
                        </Link>

                        <Fab
                            variant="extended"
                            color="default"
                            onClick={() => handleLogoutFn()}
                            className={classNames(
                              classes.whiteBorderButton,
                              //classes.whiteBorderButtonSmall,
                              // classes.incompleteDetailsOrRedButton
                            )}
                            size="small"
                          >
                            &nbsp;&nbsp;&nbsp;Logout&nbsp;&nbsp;&nbsp;
                          </Fab>
                        {/* // &nbsp;&nbsp;<span className={classes.newText}>New</span> */}
                        {/* </Link> */}
                        {/* <Link
                          to={PROFILE_ROUTES.MISSION_STATEMENTS}
                        //style={{ marginLeft: "-26px" }}
                        >
                          <Fab
                            variant="extended"
                            color="default"
                            //onClick={this.handleOpen}
                            className={classNames(
                              classes.whiteBorderButton,
                              classes.whiteBorderButtonSmall
                            )}
                            size="small"
                          >
                            Mission Statements
                          </Fab>
                        </Link> */}
                        {/* &nbsp;&nbsp;<span className={classes.newText}>New</span> */}
                        {/* <Link to={PROFILE_ROUTES.CLIENT_TESTIMONIALS}>
                          <Fab
                            variant="extended"
                            color="default"
                            //onClick={this.handleOpen}
                            className={classNames(
                              classes.whiteBorderButton,
                              classes.whiteBorderButtonSmall
                            )}
                            size="small"
                          >
                            Add Testimonials
                          </Fab>
                        </Link> */}
                        <Link to="pma?step=1&amp;openNewMailingHODialog=1">
                          {/* <Fab
                            variant="extended"
                            color="default"
                            //onClick={this.handleOpen}
                            className={classNames(
                              classes.whiteBorderButton,
                              classes.whiteBorderButtonSmall
                            )}
                            size="small"
                          >
                            Edit Designations
                          </Fab> */}
                          {/* <span className={classes.newText} style={{ position: 'absolute', bottom: (isValidROICounty ? (availableCountyAreas > 0 ? '30%' : '31.5%') : '34%'), right: '25%' }}>New</span> */}
                          {/* <Fab
                            variant="extended"
                            color="default"
                            //onClick={this.handleOpen}
                            className={classNames(
                              classes.whiteBorderButton,
                              classes.whiteBorderButtonSmall,
                              classes.flashButton
                            )}
                            size="small"
                          >
                            You have 10 New Homeowners
                          </Fab> */}
                        </Link>
                        {/* <Link to="/agent/myadvantages">
                          <Fab
                            variant="extended"
                            color="default"
                            //onClick={this.handleOpen}
                            className={classNames(classes.whiteBorderButton, classes.whiteBorderButtonSmall)}
                            size="small"
                          >
                            Edit Neighborhood Advantages
        </Fab>
                        </Link> */}
                      </Fragment>
                    ) : (
                      ""
                    )}
                    {/* //For broker admin */}
                    {isBrokerAdminSession && (
                      <Fragment>
                        <Fab
                          variant="extended"
                          color="default"
                          onClick={() => handleLogoutFn()}
                          className={classNames(
                            classes.whiteBorderButton,
                            classes.whiteBorderButtonSmall,
                            // classes.incompleteDetailsOrRedButton
                          )}
                          size="small"
                        >
                          Logout
                        </Fab>
                      </Fragment>)}
                  </div>
                </div>
              </div>
            </div>
            </div>
          </WebsiteLayout>
        </Fragment>
      </DocumentTitle>
    );
  }
}

function mapStateToProps(state) {
  return {
    availableCountyAreas: state.home.availableCountyAreas,
  };
}
//dispatch({
//   type: homeConstants.GET_SALE_PRICE_FOR_CITIES,
//   payload: res.data
// });
function mapDispatchToProps(dispatch) {
  return {
    updateAvailableAreaCount: (actionObject) => dispatch(actionObject),
  };
}

// Wrapper component to provide width using hooks
const HomeScreenWithWidth = (props) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const width = isMobile ? 'sm' : 'md';

  return <HomeScreen {...props} width={width} />;
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(compose(withStyles(styles), withRouter)(HomeScreenWithWidth));
